import { render, staticRenderFns } from "./RemarksIndicator.vue?vue&type=template&id=31028b50&scoped=true&"
import script from "./RemarksIndicator.vue?vue&type=script&lang=js&"
export * from "./RemarksIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RemarksIndicator.vue?vue&type=style&index=0&id=31028b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31028b50",
  null
  
)

export default component.exports